import "./Benefits.css";
import React, { useEffect, useState } from "react";
import "./Global.js";
import { useConfigs } from "./components/ConfigsContext";
import ReactMarkdown from "react-markdown";
import useAppImages from "./components/AppImages";
import ReactHtmlParser from "html-react-parser";

const strapiServerUrl = window.strapiServerUrl;

const Benefits = () => {
  const { loading, error, data } = useConfigs();
  const [appImages, sectionDesc] = useAppImages();
  const [benefitsData, setBenefitsData] = useState([]);
  const [benefitImage, setBenefitImage] = useState(null);
  const [benefitImageDesc, setBenefitImageDesc] = useState(null);

  useEffect(() => {
    if (data) {
      setBenefitsData(data.benefits.data);
    }
  }, [data]);

  useEffect(() => {
    if (appImages) {
      setBenefitImage(appImages["benefits"]);
    }
    if (sectionDesc) {
      setBenefitImageDesc(sectionDesc["benefits"]);
    }
  }, [appImages, sectionDesc]);

  return (
    <div className="benefits-container">
      <div className="benefits-picture-section">
        {benefitImage && (
          <img src={`${strapiServerUrl}${benefitImage}`} alt="" />
        )}
        <div className="benefits-dialog-box">
          <h1>Benefits</h1>
          {benefitImageDesc && <p>{ReactHtmlParser(benefitImageDesc)}</p>}
        </div>
      </div>
      <div className="benefits-cards-section">
        <div className="benefits-cards">
          {loading ? (
            <div>Loading...</div>
          ) : error ? (
            <div>Error: {error.message}</div>
          ) : (
            benefitsData &&
            benefitsData.map((item, index) => (
              <div className="benefits-card" key={index}>
                <img
                  src={`${strapiServerUrl}${item.attributes.icon.data.attributes.url}`}
                  width="70px"
                  height="70px"
                  alt=""
                ></img>
                <div className="benefits-card-description">
                  <h4>{item.attributes.benefit_name}</h4>
                  <ReactMarkdown>
                    {item.attributes.card_description}
                  </ReactMarkdown>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Benefits;
